/**
 * Badge métier commerce — rendu unique Admin (système / seed / custom).
 */
import TaxonomyStatusBadge from './taxonomy/TaxonomyStatusBadge';
import {
  getMetierFamilyChipClass,
  resolveMetierDisplay,
} from '../utils/metierDisplay';

/**
 * @param {object} props
 * @param {string} [props.code]
 * @param {object|null} [props.metier]
 * @param {(id: string) => object|null} [props.getMetier]
 * @param {'sm'|'md'} [props.size]
 * @param {boolean} [props.primary]
 * @param {boolean} [props.showStatus] — TaxonomyStatusBadge à côté (inactif/deprecated)
 * @param {string} [props.className]
 * @param {() => void} [props.onRemove]
 * @param {React.ReactNode} [props.trailing]
 */
export default function CommerceMetierBadge({
  code,
  metier = null,
  getMetier = null,
  size = 'sm',
  primary = false,
  showStatus = false,
  className = '',
  onRemove = null,
  trailing = null,
}) {
  const display = resolveMetierDisplay(code || metier?.id, { metier, getMetier });
  const sizeCls = size === 'md' ? 'px-2.5 py-1 text-sm' : 'px-2 py-1 text-xs';
  const colorCls = getMetierFamilyChipClass(display.familyId, { primary });

  return (
    <span className={`inline-flex items-center gap-1 max-w-full ${className}`}>
      <span
        className={`inline-flex items-center gap-1 font-semibold rounded-full border ${sizeCls} ${colorCls}`}
        title={display.id ? `Métier ${display.label}` : undefined}
        data-metier-id={display.id || undefined}
        data-metier-source={display.source}
      >
        <span aria-hidden className="shrink-0">
          {display.icon}
        </span>
        <span className="truncate">{display.label}</span>
        {primary ? <span className="opacity-70 font-medium">· principal</span> : null}
      </span>
      {showStatus && display.metier ? <TaxonomyStatusBadge entity={display.metier} /> : null}
      {trailing}
      {typeof onRemove === 'function' ? (
        <button
          type="button"
          onClick={onRemove}
          className="p-0.5 rounded hover:bg-gray-200 text-gray-500"
          aria-label={`Retirer ${display.label}`}
          title="Retirer"
        >
          ×
        </button>
      ) : null}
    </span>
  );
}
